import React from 'react'
import './DemoBanner.css'

const DemoBanner: React.FC = () => {
  if (process.env.REACT_APP_AMBIENTE_FACTURACION !== '00') return null

  return (
    <div className="demo-banner">
      Demo
    </div>
  )
}

export default DemoBanner
